import { useState, useEffect } from 'react';
import { modalManager, SimpleModalData } from '../utils/modalManager';

export const useModal = () => {
    const [modals, setModals] = useState<SimpleModalData[]>([]);

    useEffect(() => {
        const unsubscribe = modalManager.subscribe(setModals);
        return unsubscribe;
    }, []);

    const showModal = (config: Omit<SimpleModalData, 'id' | 'isOpen'>) => {
        return modalManager.show(config);
    };

    const hideModal = (id?: string) => {
        modalManager.hide(id);
    };

    const removeModal = (id?: string) => {
        modalManager.remove(id);
    };

    return {
        modals,
        showModal,
        hideModal,
        removeModal,
    };
};
